module.exports = __webpack_public_path__ + "img/rgm-default.097ea947.png";